import { FilterCriteriaForm } from '@/components/table/schemas/filterCriteriaSchema.ts';

export interface FilterCriteriaDto extends FilterCriteriaForm {
  searchTerm: string;
  quickFilters: Record<string, boolean>;
}

/** Pusty filtr do zapytań spoza tabeli (listy opcji w selectach). */
export const emptyFilterCriteria: FilterCriteriaDto = {
  filters: [],
  combinator: 'AND',
  searchTerm: '',
  quickFilters: {},
};
